import React from "react";
import { BackgroundThemedSpan } from "./ThemedSpan";

const Badge = ({ children, className, ...rest }) => {
    return (
        <BackgroundThemedSpan className={`badge ${className ? className : ''}`} {...rest}>{children}</BackgroundThemedSpan>
    )
};

export default Badge;